import AppNavbar from './AppNavbar';
import Footer from './Footer';
import TopographicBackground from './background/TopographicBackground';
import { Outlet } from 'react-router-dom';

function Layout() {
  return (
    <div className="App">
      <TopographicBackground />
      <AppNavbar className="fixed-navbar" />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
